import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20896494"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-1" }
const _hoisted_2 = { class: "text-img" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"text-wrapper\" data-v-20896494><strong class=\"guide-title\" data-v-20896494> 차별화된 1:1 <br data-v-20896494> 영어 학습 링고라 </strong><div class=\"desc-wrapper\" data-v-20896494><p class=\"guide-desc\" data-v-20896494> 링고라(Lingora)는 <strong class=\"colored-title\" data-v-20896494> 휴먼 튜터링과 AI의 첨단 기술을 바탕으로 사용자에게 맞춤형 외국어 학습 솔루션 </strong> 을 제공합니다. 학습 스타일과 목표에 맞춰 가장 적합한 학습 방법을 선택할 수 있으며, 유연하고 경제적인 옵션을 통해 높은 학습 성과를 달성할 수 있습니다. </p></div></div>", 1)
const _hoisted_5 = { class: "section" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"part\" data-v-20896494><strong class=\"title\" data-v-20896494> 국내 유일! <br data-v-20896494> 예약 없이 바로 수업 </strong><div class=\"desc-wrapper\" data-v-20896494><p class=\"desc\" data-v-20896494> 매 수업 시간, 튜터, 토픽을 직접 선택해 <br data-v-20896494><span class=\"emphasis\" data-v-20896494>예약 or 예약 없이 바로 수업</span><br data-v-20896494> 자유로운 수업을 경험해 보세요! </p></div></div>", 1)
const _hoisted_7 = { class: "text-img" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "section-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "part" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "title" }, [
    /*#__PURE__*/_createTextVNode(" 나에게 맞는 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 수업 방식 선택 ")
  ])
], -1 /* HOISTED */))
const _hoisted_11 = { class: "img-wrapper cards-wrapper" }
const _hoisted_12 = { class: "cards" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "part" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title-wrapper" }, [
      /*#__PURE__*/_createElementVNode("strong", { class: "title" }, "AI 학습 오픈!"),
      /*#__PURE__*/_createElementVNode("div", { class: "tag" }, [
        /*#__PURE__*/_createElementVNode("strong", { class: "title" }, "Beta")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "desc" }, [
      /*#__PURE__*/_createTextVNode(" 원어민 1:1 회화와 AI 학습까지 부담 없는 실력 향상! "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 베타 오픈 기간동안 AI 학습 무료로 이용하실 수 있습니다. ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "video-box" }, [
      /*#__PURE__*/_createElementVNode("video", {
        class: "video",
        playsInline: "",
        autoplay: "",
        controls: "",
        muted: "",
        src: "//res.tutoring.co.kr/res/images/web/b2b/lingoraAI_Demo.mp4"
      })
    ])
  ])
], -1 /* HOISTED */))
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"part-check\" data-v-20896494><strong class=\"title\" data-v-20896494> 업계최저가 보장! <br data-v-20896494> 상설특가제 실시 </strong><p class=\"desc\" data-v-20896494> 최고 수준의 서비스를 업계 최저가로 <br data-v-20896494> 제공하기 위한 상설특가제 실시! </p><div class=\"check\" data-v-20896494><p class=\"check-decs\" data-v-20896494>정가대비 50% 이상 상시 할인</p><p class=\"check-decs\" data-v-20896494>경쟁사 서비스 가격 모니터링 및 비교</p><p class=\"check-decs\" data-v-20896494> 최저가 신고보상제로 <span class=\"emphasis\" data-v-20896494>차액 최대 10배</span> 보상 </p></div></div>", 1)
const _hoisted_19 = { class: "img-wrapper" }
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "part" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "explain-box" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "desc" }, " 상설특가제 페이지에서 가격 비교 기준 및 경쟁사별 가격 비교 상세 내용을 확인하실 수 있습니다. ")
  ])
], -1 /* HOISTED */))
const _hoisted_22 = { class: "section" }
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"part\" data-v-20896494><strong class=\"title\" data-v-20896494> 신규 가입 시 <br data-v-20896494> 원어민과 AI 학습 무료 혜택 </strong><p class=\"desc\" data-v-20896494> 가입만 하면 누구나 <br data-v-20896494><span class=\"emphasis\" data-v-20896494>원어민 1:1 회화 수업 1회 무료 제공</span><br data-v-20896494><span class=\"emphasis\" data-v-20896494>AI 매일 5분 무료</span></p></div>", 1)
const _hoisted_24 = { class: "img-wrapper" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "section" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "part-consulting" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "title" }, [
    /*#__PURE__*/_createTextVNode(" 회원이라면 누구나 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 학습 컨설팅 무료 ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "desc" }, [
    /*#__PURE__*/_createTextVNode(" 학습법부터 수강권 추천, 동기 부여까지 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 링고라 고객이라면 누구나 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 학습 전문가 컨설팅 무료 제공! ")
  ])
], -1 /* HOISTED */))
const _hoisted_28 = { class: "img-wrapper" }
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "part-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "explain-box" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "학습 상담 신청 방법"),
    /*#__PURE__*/_createElementVNode("p", { class: "desc" }, "마이링고라 > 학습 전문 컨설턴트")
  ])
], -1 /* HOISTED */))
const _hoisted_31 = { class: "footer" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 이제 링고라와 공부하고 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 새로운 세상을 만나볼까요? ")
], -1 /* HOISTED */))
const _hoisted_33 = { class: "img-wrapper" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "btn-wrapper" }
const _hoisted_36 = { class: "share" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "친구에게 링고라를 소개해 보세요!", -1 /* HOISTED */))
const _hoisted_38 = ["src"]
const _hoisted_39 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppNav = _resolveComponent("AppNav")!
  const _component_PopupToast = _resolveComponent("PopupToast")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($options.appView)
      ? (_openBlock(), _createBlock(_component_AppNav, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode("링고라 수업가이드")
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("main", {
      class: _normalizeClass(["main", { 'is-app': $options.appView }])
    }, [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "img",
            src: `${$data.IMG_URL}guide_main.png`,
            alt: "HOW TO USE TUTORING"
          }, null, 8 /* PROPS */, _hoisted_3),
          _hoisted_4
        ])
      ]),
      _createElementVNode("section", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            class: "lesson",
            src: `${$data.IMG_URL}guide_01.png`,
            alt: "lesson-img"
          }, null, 8 /* PROPS */, _hoisted_8)
        ])
      ]),
      _createElementVNode("section", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("img", {
              class: "all-lesson",
              src: `${$data.IMG_URL}card_intro_class_01.png`,
              alt: "card_intro_class_01",
              "aria-hidden": "true"
            }, null, 8 /* PROPS */, _hoisted_13),
            _createElementVNode("img", {
              class: "voice-lesson",
              src: `${$data.IMG_URL}card_intro_class_02.png`,
              alt: "card_intro_class_02",
              "aria-hidden": "true"
            }, null, 8 /* PROPS */, _hoisted_14),
            _createElementVNode("img", {
              class: "ai-lesson",
              src: `${$data.IMG_URL}card_intro_class_03.png`,
              alt: "card_intro_class_03",
              "aria-hidden": "true"
            }, null, 8 /* PROPS */, _hoisted_15),
            _createElementVNode("img", {
              class: "ai-quiz",
              src: `${$data.IMG_URL}card_intro_class_04.png`,
              alt: "card_intro_class_04",
              "aria-hidden": "true"
            }, null, 8 /* PROPS */, _hoisted_16)
          ])
        ]),
        _hoisted_17,
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("img", {
            class: "price",
            src: `${$data.IMG_URL}guide_02.png`,
            alt: "price",
            "aria-hidden": "true"
          }, null, 8 /* PROPS */, _hoisted_20)
        ]),
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("img", {
              class: "coupon",
              src: `${$data.IMG_URL}guide_03.png`,
              alt: "coupon",
              "aria-hidden": "true"
            }, null, 8 /* PROPS */, _hoisted_25)
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("img", {
              class: "consult-view",
              src: `${$data.IMG_URL}guide_04.png`,
              alt: "consult-view",
              "aria-hidden": "true"
            }, null, 8 /* PROPS */, _hoisted_29)
          ]),
          _hoisted_30
        ])
      ])
    ], 2 /* CLASS */),
    _createElementVNode("footer", _hoisted_31, [
      _hoisted_32,
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("img", {
          class: "tudal",
          src: `${$data.IMG_URL}guide_tudal.png`,
          alt: "tudal-img",
          "aria-hidden": "true"
        }, null, 8 /* PROPS */, _hoisted_34)
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("button", {
          class: "main-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.goToService()))
        }, "링고라 시작하기")
      ]),
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("button", {
          class: "btn kakao",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.sendKakaoMsg()))
        }, [
          _createElementVNode("img", {
            src: `${$data.IMG_URL}ic_kakao.svg`,
            alt: "카카오톡으로 공유하기"
          }, null, 8 /* PROPS */, _hoisted_38)
        ])
      ])
    ]),
    _createVNode(_component_PopupToast, { isPopup: $data.isPopup }, {
      default: _withCtx(() => [
        _createElementVNode("p", { innerHTML: $data.popUpMessage }, null, 8 /* PROPS */, _hoisted_39)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isPopup"])
  ]))
}